import React from "react";
import Dropdown from "sushiweb/Dropdown";
import MenuItem from "sushiweb/MenuItem";
import Button from "sushiweb/Button";
import * as GenerateQRActions from "../../store/actions/QRGenerator";
import Input from "sushiweb/InputTypes/Input";
import H1 from "sushiweb/Typography/Heading/H1";
import H3 from "sushiweb/Typography/Heading/H3";
import H4 from "sushiweb/Typography/Heading/H4";
import { connect } from "react-redux";
import { Mark, P, Strong, Underline } from 'sushiweb/Typography';
import { QrCode } from "sushiweb/Icons"
import Slider from "sushiweb/Slider";
import * as UserActions from "../../store/actions/User";
import { bindActionCreators } from "redux";
import { set } from "date-fns";


const input = 
    {
        name: "numberOfQR",
        label: "How many?",
        type: "number",
        placeholder: "Enter Number of QR",
        helperText: "Enter the number between 0 and 20000"
    }
const InitialState = {
    vendorCode: "",
    numberOfQR: "",
};

const styles = {
container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    width: '70%',
    gap: '20px', // space between elements
},
dropdown: {
    width: '250px', // Reduced width
    height: '2px', // Reduced height
    fontSize: '12px', // Smaller font size
},
input: {
    width: '250px',
    fontSize: '50px',
    padding: '5px',
},
button: {
    width: '120px',
    height: '35px',
    fontSize: '14px',
}
};

const QRGeneratorForm = ({ generateQR, fetchVendors, setStatus }) => {
    const [state, setState] = React.useState({ ...InitialState });
    const [vendors, setVendors] = React.useState([]);
    const [errors, setErrors] = React.useState({
        numQRErr: ""
    });
    React.useEffect(() => {
        fetchVendors().then((res) => {
            console.log(res.vendors);
            setVendors(res.vendors);
            const currState = { ...state };
            setState(currState);
        });
    }, [])

    React.useEffect(() => {
    }, [state, errors])

    const isButtonDisabled = () => {
        if ((errors.numQRErr == "") && (state.vendorCode != "") && (state.numberOfQR != "")) {
            return false
        }
        return true
    }

    const handleChange = (key, e) => {

        if(key == input.name) {
            if (Number(e) > 20000 || Number(e) < 0) {
                setErrors({ numQRErr: "Enter the number between 0 and 20000" });
            } else {
                setErrors({ numQRErr: "" });
            }
        } 

        const currState = { ...state };
        currState[key] = e;
        setState(currState);
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(state);
        generateQR(state).then((res) => {
            if(res.error) {
                setStatus({
                    type: "error",
                    message: res.error
                });
            }
            else {
                setStatus({
                    type: "success",
                    message: res.message
                });
            }
        })
    }

    const handleVendorCodeSelect = (e) => {
        console.log(e);
        const currState = { ...state };
        currState["vendorCode"] = e;
        setState(currState);
    }

    return (
        <div style={ styles.container } >

             <div style={{ display: 'flex'}}>
                <div style={{ padding: '10px', margin: '10px 10px 0 0' }}>
                    <QrCode />
                </div>
                <div style={{ padding: '10px',margin: '10px 10px 0 0'  }}>
                    QR Generator
                </div>
            </div>
           
            {
                vendors ?
                    <Dropdown onSelect={handleVendorCodeSelect}
                        placeholder="Select Vendor Code"
                        showArrow={true}
                        width={styles.dropdown.width}
                        // height={styles.dropdown.height}
                    >
                    {vendors.map((vendor, index) => (
                        <MenuItem
                            key={index}
                            value={vendor.vendor_code}
                            label={vendor.vendor_code}
                        />
                    ))}
                </Dropdown>
                : <H4>No Valid Vendors Found</H4>
            }
        {
            <Input
                key={input.name}
                label={input.label}
                value={state[input.name]}
                type={input.type}
                placeholder={input.placeholder}
                onChange={(e) => handleChange(input.name, e)}
                innerWidth={styles.input.width}
                required
                errorMsg={errors.numQRErr}    
                helperText={input.helperText}
                id="sushi-input"
            />
        }
            <Button onClick={handleSubmit} style={styles.button} disabled={isButtonDisabled()}>Generate QR</Button>
                        
            <div>
                <Strong>Instructions:</Strong>
                <ul>
                    <li> Select vendor code from the dropdown. If vendor id is not listed, get it registered first. </li>
                    <li> Max number of QRs allowed: <Mark type="bg">20000</Mark></li>
                    <li> After generating, a mail will be received with the csv file attached.</li>
                    <li> Actual entries might be slightly less than expected number of entries.</li>
                </ul>
            </div>
    </div>
    );
};

function mapStateToProp(state) {
    return {};
};

function mapDispatchToProps(dispatch) {
    return {
        generateQR: (params) => dispatch(GenerateQRActions.generateQR(params)),
        fetchVendors: () => dispatch(GenerateQRActions.fetchVendors()),
        setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    };
}

export default connect(mapStateToProp, mapDispatchToProps)(QRGeneratorForm);
